import React from "react";
import { ThemeProvider } from "react-bootstrap";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LayoutComponent from "./pages/layout";
import HomePage from "./pages/homepage";
import CookieConsent from "./components/CookieConsent";
import ConsentScriptManager from "./components/ConsentScriptManager";
import "./App.css";
import "./i18n";
import { FirebaseAnalytics } from "./analytics";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <CookieConsent />
        <ConsentScriptManager />
        <BrowserRouter>
          <FirebaseAnalytics />
          <Routes>
            <Route
              path="/"
              element={
                <LayoutComponent isHomePage={true}>
                  <HomePage />
                </LayoutComponent>
              }
            />
            <Route
              path="/it"
              element={
                <LayoutComponent isHomePage={true}>
                  <HomePage />
                </LayoutComponent>
              }
            />
            <Route
              path="/en"
              element={
                <LayoutComponent isHomePage={true}>
                  <HomePage />
                </LayoutComponent>
              }
            />
            <Route
              path="/fr"
              element={
                <LayoutComponent isHomePage={true}>
                  <HomePage />
                </LayoutComponent>
              }
            />
            <Route
              path="/de"
              element={
                <LayoutComponent isHomePage={true}>
                  <HomePage />
                </LayoutComponent>
              }
            />
            <Route
              path="/es"
              element={
                <LayoutComponent isHomePage={true}>
                  <HomePage />
                </LayoutComponent>
              }
            />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}
export default App;
